<svelte:head>

<script  src="https://cdnjs.cloudflare.com/ajax/libs/pivottable/2.13.0/pivot.min.js"
			  crossorigin="anonymous"
			  defer>
  </script>  
<!-- <script  src="../dist/novix.pivottable.js"
			  crossorigin="anonymous"
			  defer>
  </script>  -->
  <script  src="../dist/highstock.js"
			  crossorigin="anonymous"
			  defer>
  </script>  
    <script  src="../dist/highcharts-more.js"
			  crossorigin="anonymous"
			  defer>
  </script>  
 <script  src="../dist/modules/treemap.js"
			  crossorigin="anonymous"
			  defer>
  </script>  
<!--   <script  src="../dist/handsontable.full.min.js"
			  crossorgin="anonymous"
			  defer>
  </script>   -->
<!--    <script  src="../dist/novix.pivot.renderer.js"
			  crossorigin="anonymous"
			  defer>
  </script>   -->
   <script  src="../dist/hightchart_renderers.js"
			  crossorigin="anonymous"
			  defer>
  </script>
  <script  src="../dist/subtotal.js"
			  crossorigin="anonymous"
			  defer>
  </script>  
<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/pivottable/2.13.0/pivot.min.css" />
<!-- <link rel="stylesheet" media="screen" href="../dist/novix.pivotttable.css" /> -->
<link rel="stylesheet" type="text/css" href="../dist/subtotal.min.css" />
<!-- <link rel="stylesheet" media="screen" href="../dist/handsontable.full.min.css" /> -->
<!-- <link rel="stylesheet" media="screen" href="../dist/pivottable_novixpivotjs_style.css" /> -->

</svelte:head>

<script>

export let data = [];

import { onMount, onDestroy } from 'svelte';



	onMount(async () => {

		setTimeout(function(){ 

			console.log(window.jQuery);
			console.log(jQuery);

			console.log(jQuery.pivotUtilities.subtotal_renderers);
			console.log(jQuery.pivotUtilities.highchart_renderers);

	        var dataClass = jQuery.pivotUtilities.SubtotalPivotData;

				var renderers = jQuery.extend({},
//															jQuery.pivotUtilities.novix_renderers, 
															jQuery.pivotUtilities.subtotal_renderers,
															jQuery.pivotUtilities.highchart_renderers,
														);
			
				jQuery("#pivot").pivotUI( data , 
					{
			         dataClass: dataClass,
						rows: ["Party","Province"],
						cols: ["Age","Gender"],
						renderers: renderers,
			                rendererName: "Table With Subtotal",
						rendererOptions: {
							onEditValues: function (changes) {
	//										jQuery(".changesOutput").html(JSON.stringify(changes));
	                        },
							onDrawTable: function (htTable) {
	//                            jQuery(".changesOutput").empty();
	                        },
						}
					});

			 }, 
			 3000);
		  
	});

</script>

<style>
</style>


<div class="diagramWrapper">
		<div id="pivot" class="pane"></div>
	</div>


